import { render, staticRenderFns } from "./FudaoTeacherExtendInviteDialog.vue?vue&type=template&id=38c0b626&"
import script from "./FudaoTeacherExtendInviteDialog.vue?vue&type=script&lang=js&"
export * from "./FudaoTeacherExtendInviteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports